import styled, { css } from 'styled-components';
import { em, rem, transparentize } from 'polished';
import { Button } from 'elements';
import { media } from 'core/layout';
import { colors, isDefaultThemeMode } from 'core/theme';

export const StyledGalerija = styled.div`
  border-bottom: 1px solid ${colors.hairline};
  margin-bottom: 3em;
  position: relative;

  ${({ insideContent }) => insideContent && css`
    margin-top: 3em;
    margin-bottom: 1em;
  `};

  @media print {
    border-bottom: 0;
    margin-bottom: 0.5em;
  }
`;

export const StyledFigure = styled.figure`
  margin: 0;

  & > img {
    width: 100%;
  }

  & > figcaption {
    color: ${colors.lightText};
    font-size: ${em(14)};
    margin: 0.75em 0;
    display: flex;

    & > span:first-child {
      flex: 0 0 auto;
    }

    & > span:not(:first-child) {
      margin-left: 4em;
    }

    ${media.tabletSmall`
      font-size: ${em(12)};
    `};

    @media print {
      & > span:first-child {
        display: none;
      }

      & > span:not(:first-child) {
        margin-left: 0;
      }
    }
  }
`;

export const ButtonNext = styled(Button)`
  border-radius: 50% !important;
  border: 2px solid ${colors.background} !important;
  width: ${rem(58)};
  height: ${rem(58)};

  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 !important;
  & > span {
    padding: 0;
    padding-left: 0.2em;
  }

  svg {
    color: ${colors.background};
    width: 2rem;
    height: 2rem;
  }

  &:hover {
    background-color: ${props => transparentize(0.5, colors.primary(props))} !important;
  }
  &:active {
    background-color: ${colors.primary} !important;
  }

  ${media.tablet`
    width: ${rem(40)};
    height: ${rem(40)};

    svg {
      width: 1rem;
      height: 1rem;
    }
  `};
`;

export const ButtonPrev = ButtonNext.extend`
  transform: scaleX(-1) !important;
`;

export const DownloadLink = styled.a`
  display: inline-block;
  margin: -0.5em;
  padding: 0.5em;
  text-decoration: none;

  display: flex;
  align-items: center;
  justify-content: center;
  transform: translate(0.5em, -0.5em);

  svg {
    color: ${colors.lightText};
  }

  &:hover {
    svg {
      background-color: ${props => isDefaultThemeMode(props) ? 'transparent' : colors.text};
      color: ${props => isDefaultThemeMode(props) ? colors.text : colors.background};
    }
  }

  &:active {
    background-color: ${colors.highlight};
  }
`



// WEBPACK FOOTER //
// ./src/pages/Raksts/components/Galerija/styled.js